<template>
  <el-dialog title="教师物资分类申请权限" :visible.sync="show" width="900px" :close-on-click-modal="false">
    <el-alert
      title="开启权限后，教师只能在采购单和领用单中选择已分配的商品分类。选择父分类会同时授权其下级分类。"
      type="info"
      :closable="false"
      show-icon
      style="margin-bottom: 16px;"
    />
    <el-row :gutter="20" v-loading="loading">
      <el-col :span="9">
        <el-input v-model="teacherKey" clearable prefix-icon="el-icon-search" placeholder="搜索教师或部门" />
        <el-table ref="teacherTable" :data="filteredTeachers" height="430" highlight-current-row
          style="margin-top: 10px;" @current-change="selectTeacher">
          <el-table-column prop="TEACHER_NAME" label="教师" min-width="100" />
          <el-table-column prop="DEPT_NAME" label="部门" min-width="110" />
        </el-table>
      </el-col>
      <el-col :span="15">
        <div v-if="currentTeacher" class="permission-panel">
          <div class="permission-title">
            正在设置：<b>{{ currentTeacher.TEACHER_NAME }}</b>
            <span v-if="currentTeacher.DEPT_NAME">（{{ currentTeacher.DEPT_NAME }}）</span>
          </div>
          <el-tree ref="categoryTree" :data="categories" node-key="ID" show-checkbox default-expand-all
            :props="{ label: 'NAME', children: 'CHILDREN' }" />
        </div>
        <div v-else class="empty-tip">请选择需要分配权限的教师</div>
      </el-col>
    </el-row>
    <div slot="footer">
      <el-button @click="show = false">取消</el-button>
      <el-button type="primary" :loading="saving" :disabled="!currentTeacher" @click="submit">保存权限</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      loading: false,
      saving: false,
      teacherKey: "",
      teachers: [],
      categories: [],
      currentTeacher: null
    };
  },
  computed: {
    filteredTeachers() {
      const key = this.teacherKey.trim();
      if (!key) return this.teachers;
      return this.teachers.filter(item =>
        (item.TEACHER_NAME || "").includes(key) || (item.DEPT_NAME || "").includes(key)
      );
    }
  },
  methods: {
    init() {
      this.show = true;
      this.loading = true;
      this.teacherKey = "";
      this.currentTeacher = null;
      this.whale.remote.getResult({
        url: "/api/School/MAT/MCatApi/GetApplyPermission",
        completed: response => {
          const data = response.DATA || {};
          this.categories = data.CATEGORIES || [];
          this.teachers = (data.TEACHERS || []).map(item => ({
            ...item,
            CAT_IDS: (item.CAT_IDS || []).slice()
          }));
          this.$nextTick(() => {
            if (this.teachers.length > 0) {
              this.$refs.teacherTable.setCurrentRow(this.teachers[0]);
              this.selectTeacher(this.teachers[0]);
            }
          });
        },
        finally: () => { this.loading = false; }
      });
    },
    captureCurrentPermission() {
      if (!this.currentTeacher || !this.$refs.categoryTree) return;
      this.currentTeacher.CAT_IDS = this.$refs.categoryTree.getCheckedKeys(false);
    },
    selectTeacher(teacher) {
      if (!teacher || teacher === this.currentTeacher) return;
      this.captureCurrentPermission();
      this.currentTeacher = teacher;
      this.$nextTick(() => this.$refs.categoryTree.setCheckedKeys(teacher.CAT_IDS || []));
    },
    submit() {
      this.captureCurrentPermission();
      this.saving = true;
      this.whale.remote.getResult({
        url: "/api/School/MAT/MCatApi/SaveTeacherCatPermission",
        data: {
          PERMISSIONS: this.teachers.map(item => ({
            TEACHER_ID: item.TEACHER_ID,
            CAT_IDS: item.CAT_IDS || []
          }))
        },
        completed: () => {
          this.show = false;
          this.$message.success("教师分类权限已保存");
        },
        finally: () => { this.saving = false; }
      });
    }
  }
};
</script>

<style scoped>
.permission-panel {
  border: 1px solid #ebeef5;
  border-radius: 4px;
  min-height: 430px;
  padding: 14px 18px;
}
.permission-title {
  border-bottom: 1px solid #ebeef5;
  margin-bottom: 12px;
  padding-bottom: 12px;
  color: #606266;
}
.empty-tip {
  color: #909399;
  padding-top: 180px;
  text-align: center;
}
</style>
